/* eslint-disable no-unused-vars */

import React from 'react';

import Icon from '@components/icon-component';
import style from './style.module.scss';

const AdditionalData = ({ isDownloaded = false }) => {
  return (
    <div className={`${style.container} ${isDownloaded && style.downloadContainer}`}>
      <div className={style.imageContainer}>
        <Icon name={isDownloaded ? 'like-icon-gray' : 'download-icon-gray'} />
      </div>
      <div className={style.content}>
        <p>{isDownloaded ? 'Additional data downloaded' : 'Requires additional data'}</p>
      </div>
    </div>
  );
};

export default AdditionalData;
